import React, { FunctionComponent } from 'react';

import { useUnit } from 'effector-react/ssr';

import { $dialogs, setIsOpenAddAddress } from '@stores/dialogs';
import { $profile } from '@stores/profile';

import { isValueSet } from '@utils/guards';

import { Dialog } from '@components/common/Dialog/Dialog';
import { AddressAddForm } from '@components/profile/AddressAddForm/AddressAddForm';

import styles from './AddressAddDialog.module.scss';

export const AddressAddDialog: FunctionComponent = () => {
    const [{ isOpenAddAddress }, setIsOpenAddAddressFn] = useUnit([$dialogs, setIsOpenAddAddress]);
    const { editedAddress } = useUnit($profile);

    const title = isValueSet(editedAddress) ? 'Редактирование адреса' : 'Добавление адреса';

    return (
        <Dialog
            isOpen={isOpenAddAddress}
            setOpen={setIsOpenAddAddressFn}
            title={title}
            classes={{ content: styles.dialogContent }}
        >
            <AddressAddForm />
        </Dialog>
    );
};
